<template>
  <div class="app-products">
    <v-header />
    <order-info />
  </div>
</template>

<script>
import VHeader from "@/components/header.vue";
import OrderInfo from "@/components/orders/OrderInfo.vue";
import User from "@/models/User.js";
// @ is an alias to /src
export default {
  name: "app-products",
  components: {
    VHeader,
    OrderInfo,
  },
  data(){
    return {
      user: new User(this.$session.get("user")),
    }
  },
  created() {
    this.checkUser();
  },
  methods: {
    checkUser() {
      if (this.user.company_id == 9) {
        this.$session.destroy();
        this.$router.push("/login").catch(() => {});
      }
    },
  },
};
</script>
